import { MessageDescriptor } from 'react-intl';

import { logWarning } from '@savgroup-front-common/configuration/appInsights/AppInsights';

import { intl } from '../helpers/intl';
import { collectMissingDynamicTerm } from '../services/dynamicTermSuggestion/dynamicTermSuggestionStore';

export type IntlMessageConfig = {
  id: string;
  values?: Record<string, string>;
  basePath: string;
};

export function isIntlMessageConfig(
  value: unknown,
): value is IntlMessageConfig {
  return typeof value === 'object' && value !== null;
}

export function safeFormattedIntlStringWithId(
  idOrConfig?: string | IntlMessageConfig,
  valuesParam?: Record<string, string>,
): string {
  let id: string | undefined;
  let values: Record<string, string> | undefined;

  if (isIntlMessageConfig(idOrConfig)) {
    const isMessageExist =
      intl?.messages[`${idOrConfig.basePath}${idOrConfig.id}`];

    values = idOrConfig.values;

    if (isMessageExist) {
      id = `${idOrConfig.basePath}${idOrConfig.id}`;
    } else {
      logWarning(
        // eslint-disable-next-line max-len
        `[PO-EDITOR]: message "${idOrConfig.basePath}${idOrConfig.id}" does not have a corresponding message in Dynamic messages.`,
      );

      if (idOrConfig.basePath) {
        collectMissingDynamicTerm({
          messageId: `${idOrConfig.basePath}${idOrConfig.id}`,
        });
      }

      id = idOrConfig.id;
    }
  } else {
    id = idOrConfig;
    values = valuesParam;
  }

  if (!id) {
    return '';
  }

  const message = { id, defaultMessage: id };

  return intl?.formatMessage(message as MessageDescriptor, values) as string;
}
